export const WORKER_FILE_NAME = 'worker.a55eee3eb10bfceec7fe.js';
